import { call, put } from 'redux-saga/effects';
import { enableMfaFailure, enableMfaSuccess } from '../actions';
import { enableMfa } from '../api';
import { EnableMfaRequestAction } from '../types';
import { ApiError, ApiResponse } from 'store/api/types';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { turnDrawerOff, turnMessageOn } from 'store/app/actions';
import { checkResponse } from 'store/utils';
import { fetchMeRequest } from 'store/auth/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* enableMfaSaga(action: EnableMfaRequestAction) {
  try {
    let err: ApiError | null;

    const { code, secretKey } = action.payload;
    const response: ApiResponse = yield call(enableMfa, code, secretKey);

    err = checkResponse(response?.responseMessage);
    if (err) throw err;

    const message: MessageData = {
      title: i18n.t('notifications.enabled'),
      description: i18n.t('notifications.mfa-enabled-successfully'),
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    yield put(enableMfaSuccess());
    yield put(fetchMeRequest());
    yield put(turnDrawerOff());
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(enableMfaFailure());
  }
}
